// Utility type to extract keys from the apiUrl
type ExtractKeys<T extends string> = T extends `${string}:${infer Rest}`
  ? Rest extends `${infer Key}/${infer Remaining}`
    ? Key | ExtractKeys<Remaining>
    : Rest
  : never;

// Overloaded function signatures
export function formatRoute<T extends string>(apiUrl: T, value: Record<ExtractKeys<T>, string | number>): string;

// Implementation of the function
export function formatRoute(apiUrl: string, value: Record<string, string | number>): string {
  return Object.keys(value).reduce((result, cur) => {
    result = result.replaceAll(`:${cur}`, (value[cur] ?? "").toString() || "");
    return result;
  }, apiUrl);
}

export function addParams(url: string, values: Record<string, string | number | boolean>): string {
  const query = Object.entries(values)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");

  const separator = url.includes("?") ? "&" : "?";
  return query ? `${url}${separator}${query}` : url;
}
